import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PermissionsGate from "../PermissionsGate";
import Support from "./support/Support";
import { CustomersList, CustomerView } from "./customers";
import Groups from "./groups/Groups";
import DomainsList from "./domains/DomainsList";
import { EngineProvider } from "../../contexts/EngineContext";

const Inventory = () => {

    const moduleName = "inventory";

    return (
        <EngineProvider>
            <Routes>
                <Route
                    path="/customers"
                    element={
                        <PermissionsGate module={moduleName} submodule="customers">
                            <CustomersList />
                        </PermissionsGate>
                    }
                />
                <Route
                    path="/customers/:customerId"
                    element={
                        <PermissionsGate module={moduleName} submodule="customers">
                            <CustomerView />
                        </PermissionsGate>
                    }
                />
                <Route
                    path="/customers/:customerId/:tab"
                    element={
                        <PermissionsGate module={moduleName} submodule="customers">
                            <CustomerView />
                        </PermissionsGate>
                    }
                />
                <Route
                    path="/support"
                    element={
                        <PermissionsGate module={moduleName} submodule="support">
                            <Support />
                        </PermissionsGate>
                    }
                />
                <Route
                    path="/groups"
                    element={
                        <PermissionsGate module={moduleName} submodule="groups">
                            <Groups />
                        </PermissionsGate>
                    }
                />
                <Route
                    path="/domains"
                    element={
                        <PermissionsGate module={moduleName} submodule="domains">
                            <DomainsList />
                        </PermissionsGate>
                    }
                />
                <Route path="*" element={<Navigate to="/customers" />} />
            </Routes>
        </EngineProvider>
    );
};

export default Inventory;